import styled from '@emotion/styled';
import { css } from 'twin.macro';

export const OptionsContainer = styled('div')`
    display: flex;
    flex-wrap: wrap;
    gap: 1.5rem;
`;

export const OptionDiv = styled('div')`
    display: flex;
    align-items: flex-start;
    padding: 0.5rem 0.75rem;
    border: 1px solid #ddd;
    border-radius: 4px;
    min-width: 0;
    flex: 1 1 auto;
    .form-check-input {
        cursor: pointer !important;
        margin-right: 0.75rem;
        flex-shrink: 0;
    }
    .form-check-label {
        cursor: pointer !important;
        margin: 0 !important;
        padding: 0 !important;
        padding: 0rem 0.75rem !important;
        line-height: 1.4;
        flex: 1;
        word-wrap: break-word;
        overflow-wrap: break-word;
    }
`;
export const SelectStyles = css`
    display: inline-block;
    min-width: max(400px, 50%);
    .form-control {
        min-width: max(400px, 50%);
    }
`;
